import list from "emun.cust/list/cust-list.table.htm";
import cards from "emun.cust/list/cust-list.cards.htm";

export default {
  list,
  cards,
};
